// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14-i6","name":"Header_name__KKkWT","birthday":"Header_birthday__19COU","skeleton":"Header_skeleton__28Gp1"};